import React from "react";
import { Typography, Grid, Divider } from "@mui/material";
const HiTypeHeader = ({
  date,
  name,
  encounter,
  practitionerDetails,
  organizationDetails,
}) => {
  console.log(
    "HiTypeHeader",
    name,
    date,
    encounter,
    practitionerDetails,
    organizationDetails
  );
  const formatDateTime = (dateTimeString) => {
    if (!(dateTimeString && dateTimeString.length > 0)) {
      return { formattedDate: null, formattedTime: null };
    }
    const dateObj = new Date(dateTimeString);
    console.log("Visit Date time", dateObj);
    // Get date in 24-June-2024 format
    const optionsDate = { day: "2-digit", month: "long", year: "numeric" };
    const formattedDate = dateObj
      .toLocaleDateString("en-GB", optionsDate)
      .replace(/\s/g, "-");

    // Get time in 06:23 AM/PM format
    const optionsTime = { hour: "2-digit", minute: "2-digit", hour12: true };
    const formattedTime = dateObj.toLocaleTimeString("en-US", optionsTime);

    return { formattedDate, formattedTime };
  };
  // console.log("Encounter details", encounter);
  const { formattedDate, formattedTime } = formatDateTime(
    Array.isArray(encounter) &&
      encounter.length > 0 &&
      encounter[0]?.start_date?.length > 0
      ? encounter[0].start_date
      : date
  );
  return (
    <Grid
      container
      spacing={2}
      sx={{
        padding: "5px 20px 5px 5px",
        display: "flex",
        alignItems: "center",
        alignContent: "center",
        width: "100%",
        margin: "5px !important",
      }}
    >
      {encounter && (
        <Grid item xs={12} sm={12} sx={{ margin: "1px 0px" }}>
          <Typography>
            {encounter?.[0]?.encounter_type?.display ?? "NA"}
          </Typography>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sm={12}
        sx={{
          margin: "1px 0px  5px 0px",
        }}
      >
        <Typography>{name ? name : "NA"}</Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        sx={{
          margin: "1px 0px  5px 0px",
        }}
      >
        <Divider />
      </Grid>
      <Grid item xs={6} sm={6} sx={{ margin: "1px 0px" }}>
        <Typography>Practitioner Name</Typography>
      </Grid>
      <Grid item xs={6} sm={6} sx={{ margin: "1px 0px", textAlign: "right" }}>
        <Typography>
          {typeof practitionerDetails?.[0]?.name?.[0] === "object" &&
          practitionerDetails?.[0]?.name?.[0] !== null
            ? practitionerDetails[0].name[0].text || "NA"
            : practitionerDetails?.[0]?.name?.[0] ?? "NA"}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={6} sx={{ margin: "1px 0px" }}>
        <Typography>Clinic Name</Typography>
      </Grid>
      <Grid item xs={6} sm={6} sx={{ margin: "1px 0px", textAlign: "right" }}>
        <Typography>{organizationDetails?.[0]?.name ?? "NA"}</Typography>
      </Grid>
      <Grid item xs={12} sm={6} sx={{ margin: "1px 0px" }}>
        <Typography>Visit Date</Typography>
      </Grid>
      <Grid item xs={8} sm={4} sx={{ margin: "1px 0px", textAlign: "right" }}>
        <Typography>
          {formattedDate ? formattedDate : "Invalid Date"}
        </Typography>
      </Grid>
      <Grid item xs={4} sm={2} sx={{ margin: "1px 0px", textAlign: "right" }}>
        <Typography>
          {formattedTime ? formattedTime : "Invalid Time"}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default HiTypeHeader;
